import { useQuery } from "@tanstack/react-query";
import { getApp } from "firebase/app";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import { USER_COLLECTION } from "src/utils/collectionsIds";
import { usersTypes } from "src/utils/constants";

export default function useGetInstructors() {
  return useQuery({
    queryKey: ["instructors"],
    queryFn: async () => {
      const app = getApp();
      const db = getFirestore(app);
      const usersColRef = collection(db, USER_COLLECTION);
      const instructorsQuery = query(
        usersColRef,
        where("userType", "==", usersTypes.instructor)
      );
      const instructorsSnapshot = await getDocs(instructorsQuery);
      if (instructorsSnapshot.empty) return { instructors: [] };
      const instructors = instructorsSnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      return { instructors };
    },
  });
}
